const {KitModule, registerModule} = window;

class Counter extends KitModule {
  constructor($element) {
    super($element, {observer: {threshold: 0.3}});
    this.animated = false;
  }

  onViewportEnter() {
    if (this.animated) {
      return;
    }

    const numbers = this.$element.querySelectorAll('.counter__number');
    numbers.forEach((number) => {
      const target = +number.getAttribute('data-number');
      const duration = 2000; // 2 seconds
      const startTime = Date.now();

      const animate = () => {
        const elapsedTime = Date.now() - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const currentNumber = Math.floor(progress * target);

        number.textContent = currentNumber.toLocaleString();

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          number.textContent = target.toLocaleString();
        }
      };

      requestAnimationFrame(animate);
    });

    this.animated = true;
  }
}

registerModule('Counter', Counter);
